import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import BuyflowReviewDetailsForm from "./indexForm";
import CircularProgress from "@mui/material/CircularProgress";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import {
  downloadFile,
  getRoute,
  getStorageItem,
  makeid,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import { postWebService } from "../../../helpers/server";

function BuyflowReviewDetails({ classes: { loaderBox } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [backdrop, setBackdrop] = useState(false);
  const [errors, setErrors] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [declaration, setDeclaration] = useState({
    agree: false,
  });
  const [modal, setModal] = useState({ open: false });

  const checkboxes = [
    {
      value: "agree",
      title: "I hereby provide my consent to proceed with the process.",
    },
  ];

  useEffect(() => {
    const cbSuccessFetchDocuments = ({ data }, checksum) => {
      setIsFormSubmitted(false);
      let dataSlice = data.slice(9);
      dataSlice = dataSlice.slice(0, -8);
      const dataJSON = JSON.parse(atob(dataSlice));

      if (dataJSON.code == 200 && dataJSON.checksum == checksum) {
        dispatchEvent(ReducerUtils.proposal.documents, dataJSON.data);
        setTimeout(() => setIsLoaded(true), 100);
      } else {
        setErrors(new Array(dataJSON?.msg));
      }
    };

    async function fetchDocuments() {
      try {
        const checksum = makeid();
        const response = await postWebService("document-listing.php", {
          oid: Number(getStorageItem("oid")),
          checksum,
        });

        cbSuccessFetchDocuments(response.data, checksum);
      } catch (error) {
        cbError(error);
      }
    }

    fetchDocuments();
  }, []);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const navigateTo = (pathname) => history.push({ pathname });

  const handleChange = (event) => {
    setDeclaration({
      ...declaration,
      [event.target.name]: event.target.checked,
    });
  };

  const handleBack = () => navigateTo(getRoute("nominee"));

  const handleDownload = (url, filename) => downloadFile(url, filename);

  const cbError = (error = null, msg = null) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
    setErrors(new Array(msg));
  };

  const cbSuccessProposalConfirmation = ({ data, code, msg }) =>
    code === 200 ? navigateTo(getRoute("mandate")) : cbError(null, msg);

  const updateProposalConfirmation = async () => {
    try {
      setIsFormSubmitted(true);
      setBackdrop(true);
      setErrors([]);
      const response = await postWebService("proposal-confirmation.php", {
        oid: Number(getStorageItem("oid")),
      });

      cbSuccessProposalConfirmation(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    updateProposalConfirmation();
  };

  return isLoaded && state?.documents?.length > 0 ? (
    <BuyflowReviewDetailsForm
      checkboxes={checkboxes}
      declaration={declaration}
      errors={errors}
      handleBack={handleBack}
      handleChange={handleChange}
      handleDownload={handleDownload}
      isFormSubmitted={isFormSubmitted}
      modal={modal}
      onSubmit={onSubmit}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowReviewDetails);
